import { memo } from 'react';
import { useHistory } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Button from 'components/Form/Button';

import useGlobalState from 'actions';
import encryptedLocalStorage from 'utils/encryptedLocalStorage';

const PersonalIdentityDialog = ({ preOpen }: { preOpen: boolean }) => {
  const [, actions] = useGlobalState();
  const history = useHistory();

  const handleClickContinue = () => {
    actions.openPersonalIdentityDialog('preOpen', false);
  };

  const handleClickSkip = () => {
    actions.openPersonalIdentityDialog('preOpen', false);
    encryptedLocalStorage.setItem(
      'customerName',
      encryptedLocalStorage.getItem('fullname'),
    );
    localStorage.setItem('dataType', 'personal_identity');
    history.push('/home');
  };

  return (
    <Dialog open={preOpen} className='forgot-dialog'>
      <DialogTitle id='pi'>
        <div style={{ textAlign: 'center' }} className='personalDialogHeader'>
          Apakah Anda yakin?
        </div>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            textAlign: 'center',
            marginLeft: 5,
            marginRight: 5,
            width: '98%',
          }}
          className='tnCContent'
        >
          <span className='personalDialogContent'>
            Jika Anda tidak menyelesaikan formulir pengajuan ini, pengajuan
            pinjaman Anda tidak akan diproses.
          </span>
          <div style={{ margin: '16px 0px' }}>
            <Button onClick={handleClickContinue} variant='contained'>
              Lanjutkan
            </Button>
          </div>
          <div>
            <Button onClick={handleClickSkip} variant='outlined'>
              Lewati
            </Button>
            <br />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(PersonalIdentityDialog);
